export type userNumberType = number | null

export enum UserStatus {
  UNPOST = 'UNPOST',
  POST = 'POST',
  FAIL = 'FAIL',
  DONE = 'DONE',
}

export interface UserType {
  uid: number | null
  identificationCard: string | null
  phone: string
  deposit: userNumberType
  avatar?: string
  depositDetail: DepositDetailType
  blockMoney: DepositDetailType
  money: DepositDetailType
  cash: boolean
  auth: UserStatus
  realName: string
  forbidden: number
  bindWechat: boolean
  nickName: string
  vip: boolean
  marketType: string
  signFinish: boolean
  contractFinish: number
  showBuy: boolean
}

export interface DepositDetailType {
  reqOrRefundShowName: string
  reqOrRefundMoney: userNumberType
  freeze: userNumberType
  reqDeposit: userNumberType
  maxRefund: userNumberType
  total: userNumberType
  used: userNumberType
  free: userNumberType
  curSell: CurSellType
  curBuy: CurBuyType
  policy: PolicyType
  problem: boolean
  exemption: ExemptionType
}

export interface ExemptionType {
  auth: boolean
  face: boolean
  buy: userNumberType
  sell: userNumberType
  enabled: boolean
  authStatus: string
  policy: ExemptionPolicyType
}

export interface ExemptionPolicyType {
  authSell: userNumberType
  faceSell: userNumberType
  authBuy: userNumberType
  faceBuy: userNumberType
}

/* 协议类型 */
export enum AgreementType {
  REGISTER = 'REGISTER', // 用户协议类型;注册协议
  TRANSPORT = 'TRANSPORT', // 货运基本条例
  EXTRA_AIR_INSURANCE = 'EXTRA_AIR_INSURANCE', // 附加航空
  EXTRA_EXPRESS_INSURANCE = 'EXTRA_EXPRESS_INSURANCE', // 附加邮保险-
  PRIVACY_POLICY = 'PRIVACY_POLICY', // 用户隐私政策
  LOCK_PRICE = 'LOCK_PRICE', // 定价协议
  STORAGE = 'STORAGE', // 存料协议
  TRANSPORT_POLICY = 'TRANSPORT_POLICY', // 运输协议
  GATHERED_USER_INFO = 'GATHERED_USER_INFO', // 已收集个人信息清单
  APP_PERMISSION = 'APP_PERMISSION', // 应用权限列表
  SDK_LIST = 'SDK_LIST', // 接入第三方SDK目录
}

export interface UserSignAgreementType {
  id: number
  type: AgreementType
  content: string
  updated: number
  name: string
}
